import { Navigate } from "react-router";

export function SubProcessorsPage() {
  return <Navigate replace to={{ pathname: "/trust", hash: "#sub-processors" }} />;
}
